<template>
  <div>
    <!-- Route Making Dedicated View (role = 3) -->
    <route-making-routes v-if="isRouteMaking"></route-making-routes>

    <!-- Super Admin (role = 0) Old Routes Screen (Unchanged) -->
    <v-card v-else>
      <v-card-title>
      <v-icon color="primary">
        mdi-road-variant
      </v-icon>
        <span class="px-2">
            {{ $t("routes") }}
        </span>
        <v-spacer></v-spacer>
        <create-button @create="createRoute"></create-button>
        <activation-tool-tip model="routes"></activation-tool-tip>
      </v-card-title>
      <v-data-table
        :no-data-text="$t('noData')"
        :no-results-text="$t('noResults')"
        item-key="name"
        :loading="isLoading"
        :loading-text="$t('loading_text')"
        :headers="translatedHeaders"
        :items="routes"
        :search="search"
        :footer-props="footerProps"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('search')"
            class="mx-4"
          ></v-text-field>
        </template>

        <template v-slot:item.created_at="{ item }">
          <small>{{ item.created_at | moment("LL") }}</small> -
          <small class="text-muted">{{ item.created_at | moment("LT") }}</small>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mx-2" @click="viewRoute(item)">
            mdi-eye
          </v-icon>
          <v-icon small class="mx-2" @click="editRoute(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mx-2" @click="deleteRoute(item, routes.indexOf(item))">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ActivationToolTip from "@/components/ActivationToolTip";
import CreateButton from "@/components/CreateButton";
import auth, { getUserRole } from '@/services/AuthService';
import RouteMakingRoutes from "./RouteMakingRoutes.vue";

export default {
  components: {
    ActivationToolTip,
    CreateButton,
    RouteMakingRoutes,
  },
  data() {
    return {
      isRouteMaking: getUserRole() === 3,
      routes: [],
      isLoading: false,
      search: "",
      headers: [
        { text: "id", value: "id", align: "start", filterable: false },
        { text: "Name", value: "name" },
        { text: "Stops", value: "stops_count" },
        { text: "created_at", value: "created_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    translatedHeaders() {
      return this.headers.map(header => ({
        ...header,
        text: this.$t(header.text)
      }));
    },
    footerProps() {
      return {
        itemsPerPageText: this.$t("rows_per_page"),
      }
    }
  },
  mounted() {
    if (!this.isRouteMaking) {
      this.loadRoutes();
    }
  },
  methods: {
    loadRoutes() {
      this.isLoading = true;
      this.routes = [];
      axios
        .get(`/routes/all`)
        .then((response) => {
          this.routes = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: this.$t("Error"),
            text: this.$t("error_retrieving_routes"),
            type: 'error'
          });
          console.log(error);
          auth.checkError(error.response.data.message, this.$router, this.$swal);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    createRoute() {
      this.$swal
        .fire({
          title: this.$t("enter_route_name"),
          input: "text",
          inputPlaceholder: this.$t("new_route"),
          showCancelButton: true,
          cancelButtonText: this.$t("cancel"),
          confirmButtonText: this.$t("save"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            const value = result.value.trim();
            this.$router.push({
              name: "create-route",
              params: { route_name: value ? value : "Untitled" },
            });
          }
        });
    },
    viewRoute(route) {
      this.$router.push({
        name: "view-route",
        params: { route_id: route.id},
      });
    },
    editRoute(route) {
      this.$swal
        .fire({
          title: this.$t("enter_route_name"),
          input: "text",
          inputValue: route.name,
          showCancelButton: true,
          cancelButtonText: this.$t("cancel"),
          confirmButtonText: this.$t("save"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            const value = result.value.trim();
            // this.$router.push({
            //   name: "create-route",
            //   params: { route_name: value ? value : "Untitled" },
            // });
            this.$router.push({
              name: "edit-route",
              params: { route_id: route.id, new_route_name: value ? value : "Untitled" },
            });
          }
        });

    },
    deleteRoute(route, index) {
      this.$swal
        .fire({
          title: this.$t("delete_route"),
          text: this.$t("confirm_delete_route", { name: route.name }),
          icon: "error",
          showCancelButton: true,
          confirmButtonText: this.$t("yes_delete"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteRouteServer(route.id, index);
          }
        });
    },
    deleteRouteServer(route_id, index) {
      axios
        .delete(`/routes/${route_id}`)
        .then((response) => {
          this.routes.splice(index, 1);
          this.$notify({
            title: this.$t("Success"),
            text: this.$t("route_deleted"),
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            title: this.$t("Error"),
            text: this.$t("error_deleting_routes"),
            type: 'error'
          });
          this.$swal("Error", error.response.data.message, "error");
        })
        .then(() => {
          //this.isDeleting = false;
        });
    },
  },
};
</script>
